import React, { useEffect } from "react";
import { Spin, Typography } from "antd";
import { base62ToUuid } from "./base62";
import "./PostVisitDocUploadPage.less";

const { Text } = Typography;

const PostVisitDocShortRedirect = ({ match }) => {
  const shortId = match.params.shortId;

  useEffect(() => {
    const token = base62ToUuid(shortId);
    if (token) {
      window.location.replace(
        `/link-uploads/post-visit-upload/?token=${encodeURIComponent(token)}`
      );
    }
  }, [shortId]);

  const token = base62ToUuid(shortId);
  if (!token) {
    return (
      <div className="pv-upload-page">
        <Text type="danger">Invalid upload link</Text>
      </div>
    );
  }

  return (
    <div className="pv-upload-page pv-upload-loading">
      <Spin size="large" />
      <Text type="secondary">Opening upload page…</Text>
    </div>
  );
};

export default PostVisitDocShortRedirect;
